/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Route, Switch, Redirect } from 'react-router-dom'
import { USER_ROLES } from 'constants/user'
import { ROUTES } from 'constants/routes'
import Alerts from 'apps/Alerts'
import LoadingOverlay from 'apps/LoadingOverlay'
import Main from 'routes/Main'
import CreateProfile from 'routes/CreateProfile'
import Login from 'routes/Login'
import ForgotPassword from 'routes/ForgotPassword'
import ConfirmEmail from 'routes/ConfirmEmail'
import ConfirmChangeEmail from 'routes/ConfirmChangeEmail'
import ChangePassword from 'routes/ChangePassword'
import Profile from 'routes/Profile'
import ContactUs from 'routes/ContactUs'
import LeaveEmail from 'routes/LeaveEmail'
import NoAvailablePrinter from 'routes/NoAvailablePrinter'
import CookieAccept from './apps/CookieAccept'
import * as styles from './CoreLayout.scss'

const cx = classNames.bind(styles)

const CoreLayout = ({ isCookieAccepted, isDataSending, userRole }) => (
  <div
    className={cx(
      'root',
    )}
  >
    <Alerts/>
    <Switch>
      <Route path={[ROUTES.home.home, ROUTES.home.menu]} component={Main} exact/>
      {userRole !== USER_ROLES.subscriptionUser && [
        <Route key='signUp' path={ROUTES.home.signUp} component={CreateProfile} exact/>,
        <Route key='login' path={ROUTES.home.logIn} component={Login} exact/>,
        <Route key='forgotPassword' path={ROUTES.home.forgotPassword} component={ForgotPassword} exact/>,
        <Route key='changePassword' path={Object.values(ROUTES.home.changePassword)} component={ChangePassword} exact/>,
        <Route
          key='noAvailablePrinter'
          path={ROUTES.home.noAvailablePrinter}
          component={NoAvailablePrinter}
          exact
        />,
      ]}
      <Route path={Object.values(ROUTES.home.confirmEmail)} component={ConfirmEmail} exact/>
      <Route path={ROUTES.home.confirmChangeEmail} component={ConfirmChangeEmail} exact/>
      <Route path={ROUTES.home.contactUs} component={ContactUs} exact/>
      <Route path={ROUTES.home.leaveEmail} component={LeaveEmail} exact/>
      {userRole === USER_ROLES.subscriptionUser && (
        <Route component={Profile} />
      )}
      <Redirect from={ROUTES.profile.view} to={ROUTES.home.logIn} />
      <Redirect to={ROUTES.home.home} />
    </Switch>
    {/* {!isCookieAccepted && <CookieAccept />} */}
    {isDataSending && <LoadingOverlay />}
  </div>
)

export default CoreLayout
